<template>
    <div>
        <div
            v-if="showMessageEmailSent()"
            class="container d-flex flex-column align-items-center py-5"
            :class="{'mt-5': layout}"
        >
            <p class="text-center">
            <strong>{{$t('emails.verify.little_missing')}}!</strong>
            {{$t('emails.verify.link_sent')}}.
            </p>
            <BaseButton
                outline
                :loading="loading"
                class="pill btn-sm px-6 mt-2"
                :style="{
                    borderColor: color.primary,
                    color: color.primary,
                    backgroundColor: '#fff',
                }"
                @click="sendLink()">
                {{ $t('emails.verify.click_another_send') }}
            </BaseButton>
        </div>
        <VerifyEmailSending
            v-model="showSentMessage"
            @close="showSentMessage=false"
        />
    </div>
</template>
<script>

import BaseButton from '../../argon/components/BaseButton';
import VerifyEmail from '../../mixins/VerifyEmail';
import VerifyEmailSending from './VerifyEmailSending';

export default {
    name: 'VerifyEmailAnotherSending',
    mixins: [
        VerifyEmail,
    ],
    components: {
        BaseButton,
        VerifyEmailSending,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        statusValidationEmail: {
            required: true,
        },
    },
    data() {
        return {
            disabledPages: ['/plans', '/cart'],
            showSentMessage: false,
            loading: false,
        };
    },
    computed: {
        currentLocation() {
            return window.location.pathname;
        },
        disableInPages() {
            return this.disabledPages.some(page => this.currentLocation === page);
        },
        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },

    },
    methods: {
        showMessageEmailSent() {
            if ((
                this.currentLocation === '/' && this.statusValidationEmail) ||
                this.user.email_verified_at ||
                this.disableInPages
            ) {
                return false;
            }
            return true;
        },
    },
};
</script>

<style>

</style>
